/**
 * 巻物（歴史年表）の開閉アニメーション
 * #makimono-content-inner の高さを取得し #makimono-content の height を transition でアニメーションする
 */

import { $ } from "./utils.js";

const DURATION_MS = 400;
const EASING = "cubic-bezier(0.65, 0, 0.35, 1)";

function initMakimono() {
  const trigger = $("#makimono-trigger");
  const content = $("#makimono-content");
  const inner = $("#makimono-content-inner");

  if (!trigger || !content || !inner) return;

  let isOpen = false;

  function getContentHeight() {
    return inner.scrollHeight;
  }

  function open() {
    const height = getContentHeight();
    content.style.height = `${height}px`;
    trigger.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");
    isOpen = true;
  }

  function close() {
    const currentHeight = content.offsetHeight;
    content.style.height = `${currentHeight}px`;
    trigger.setAttribute("aria-expanded", "false");
    content.setAttribute("aria-hidden", "true");

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
    isOpen = false;
  }

  function toggle() {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }

  // 初期状態を明示（閉じ＋transition 用）
  content.style.height = "0px";
  content.style.transition = `height ${DURATION_MS}ms ${EASING}`;

  trigger.addEventListener("click", toggle);
  trigger.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  });

  const resizeObserver = new ResizeObserver(() => {
    if (isOpen) {
      content.style.height = `${getContentHeight()}px`;
    }
  });
  resizeObserver.observe(inner);
}

export function init() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMakimono);
  } else {
    initMakimono();
  }
}
